export default __webpack_public_path__ + "static/media/yaron_shefer.cfa1e60c.jpg";